import { default as iframefhqBLuZTz9Meta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/chirashi/iframe.vue?macro=true";
import { default as indexnDi96ozyLYMeta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/chirashi/index.vue?macro=true";
import { default as viewer1EJJEcZMM7Meta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/chirashi/viewer.vue?macro=true";
import { default as _91id_93FbYPloEnzbMeta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/content/[id].vue?macro=true";
import { default as indexoOLcPc45T2Meta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/faq/index.vue?macro=true";
import { default as indexLjBxnYtjmiMeta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/index.vue?macro=true";
import { default as index33XNMauYcJMeta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/maker-theme/index.vue?macro=true";
import { default as indexCL3p4OTW39Meta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/maker-theme/survey/index.vue?macro=true";
import { default as indexFjBSfwNHNbMeta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/my-store/index.vue?macro=true";
import { default as _91type_93syEQYzenB6Meta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/my-store/search/[type].vue?macro=true";
import { default as indexvulOgDkyIPMeta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/my-store/search/index.vue?macro=true";
import { default as indexPBWCv3sOBwMeta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/preview/chirashi/index.vue?macro=true";
import { default as viewerGRNYGZK5K1Meta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/preview/chirashi/viewer.vue?macro=true";
import { default as indexx1G75sZaWOMeta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/privacy-policy/index.vue?macro=true";
import { default as indexDt1AbPWIRrMeta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/product/index.vue?macro=true";
import { default as indexHi5TUviqX4Meta } from "/Users/yuto.yasuoka/Project/chirashi-viewer/pages/theme/index.vue?macro=true";
export default [
  {
    name: iframefhqBLuZTz9Meta?.name ?? "chirashi-iframe",
    path: iframefhqBLuZTz9Meta?.path ?? "/chirashi/iframe",
    meta: iframefhqBLuZTz9Meta || {},
    alias: iframefhqBLuZTz9Meta?.alias || [],
    redirect: iframefhqBLuZTz9Meta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/chirashi/iframe.vue").then(m => m.default || m)
  },
  {
    name: indexnDi96ozyLYMeta?.name ?? "chirashi",
    path: indexnDi96ozyLYMeta?.path ?? "/chirashi",
    meta: indexnDi96ozyLYMeta || {},
    alias: indexnDi96ozyLYMeta?.alias || [],
    redirect: indexnDi96ozyLYMeta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/chirashi/index.vue").then(m => m.default || m)
  },
  {
    name: viewer1EJJEcZMM7Meta?.name ?? "chirashi-viewer",
    path: viewer1EJJEcZMM7Meta?.path ?? "/chirashi/viewer",
    meta: viewer1EJJEcZMM7Meta || {},
    alias: viewer1EJJEcZMM7Meta?.alias || [],
    redirect: viewer1EJJEcZMM7Meta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/chirashi/viewer.vue").then(m => m.default || m)
  },
  {
    name: _91id_93FbYPloEnzbMeta?.name ?? "content-id",
    path: _91id_93FbYPloEnzbMeta?.path ?? "/content/:id()",
    meta: _91id_93FbYPloEnzbMeta || {},
    alias: _91id_93FbYPloEnzbMeta?.alias || [],
    redirect: _91id_93FbYPloEnzbMeta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/content/[id].vue").then(m => m.default || m)
  },
  {
    name: indexoOLcPc45T2Meta?.name ?? "faq",
    path: indexoOLcPc45T2Meta?.path ?? "/faq",
    meta: indexoOLcPc45T2Meta || {},
    alias: indexoOLcPc45T2Meta?.alias || [],
    redirect: indexoOLcPc45T2Meta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/faq/index.vue").then(m => m.default || m)
  },
  {
    name: indexLjBxnYtjmiMeta?.name ?? "index",
    path: indexLjBxnYtjmiMeta?.path ?? "/",
    meta: indexLjBxnYtjmiMeta || {},
    alias: indexLjBxnYtjmiMeta?.alias || [],
    redirect: indexLjBxnYtjmiMeta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index33XNMauYcJMeta?.name ?? "maker-theme",
    path: index33XNMauYcJMeta?.path ?? "/maker-theme",
    meta: index33XNMauYcJMeta || {},
    alias: index33XNMauYcJMeta?.alias || [],
    redirect: index33XNMauYcJMeta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/maker-theme/index.vue").then(m => m.default || m)
  },
  {
    name: indexCL3p4OTW39Meta?.name ?? "maker-theme-survey",
    path: indexCL3p4OTW39Meta?.path ?? "/maker-theme/survey",
    meta: indexCL3p4OTW39Meta || {},
    alias: indexCL3p4OTW39Meta?.alias || [],
    redirect: indexCL3p4OTW39Meta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/maker-theme/survey/index.vue").then(m => m.default || m)
  },
  {
    name: indexFjBSfwNHNbMeta?.name ?? "my-store",
    path: indexFjBSfwNHNbMeta?.path ?? "/my-store",
    meta: indexFjBSfwNHNbMeta || {},
    alias: indexFjBSfwNHNbMeta?.alias || [],
    redirect: indexFjBSfwNHNbMeta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/my-store/index.vue").then(m => m.default || m)
  },
  {
    name: _91type_93syEQYzenB6Meta?.name ?? "my-store-search-type",
    path: _91type_93syEQYzenB6Meta?.path ?? "/my-store/search/:type()",
    meta: _91type_93syEQYzenB6Meta || {},
    alias: _91type_93syEQYzenB6Meta?.alias || [],
    redirect: _91type_93syEQYzenB6Meta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/my-store/search/[type].vue").then(m => m.default || m)
  },
  {
    name: indexvulOgDkyIPMeta?.name ?? "my-store-search",
    path: indexvulOgDkyIPMeta?.path ?? "/my-store/search",
    meta: indexvulOgDkyIPMeta || {},
    alias: indexvulOgDkyIPMeta?.alias || [],
    redirect: indexvulOgDkyIPMeta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/my-store/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexPBWCv3sOBwMeta?.name ?? "preview-chirashi",
    path: indexPBWCv3sOBwMeta?.path ?? "/preview/chirashi",
    meta: indexPBWCv3sOBwMeta || {},
    alias: indexPBWCv3sOBwMeta?.alias || [],
    redirect: indexPBWCv3sOBwMeta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/preview/chirashi/index.vue").then(m => m.default || m)
  },
  {
    name: viewerGRNYGZK5K1Meta?.name ?? "preview-chirashi-viewer",
    path: viewerGRNYGZK5K1Meta?.path ?? "/preview/chirashi/viewer",
    meta: viewerGRNYGZK5K1Meta || {},
    alias: viewerGRNYGZK5K1Meta?.alias || [],
    redirect: viewerGRNYGZK5K1Meta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/preview/chirashi/viewer.vue").then(m => m.default || m)
  },
  {
    name: indexx1G75sZaWOMeta?.name ?? "privacy-policy",
    path: indexx1G75sZaWOMeta?.path ?? "/privacy-policy",
    meta: indexx1G75sZaWOMeta || {},
    alias: indexx1G75sZaWOMeta?.alias || [],
    redirect: indexx1G75sZaWOMeta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/privacy-policy/index.vue").then(m => m.default || m)
  },
  {
    name: indexDt1AbPWIRrMeta?.name ?? "product",
    path: indexDt1AbPWIRrMeta?.path ?? "/product",
    meta: indexDt1AbPWIRrMeta || {},
    alias: indexDt1AbPWIRrMeta?.alias || [],
    redirect: indexDt1AbPWIRrMeta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexHi5TUviqX4Meta?.name ?? "theme",
    path: indexHi5TUviqX4Meta?.path ?? "/theme",
    meta: indexHi5TUviqX4Meta || {},
    alias: indexHi5TUviqX4Meta?.alias || [],
    redirect: indexHi5TUviqX4Meta?.redirect || undefined,
    component: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/pages/theme/index.vue").then(m => m.default || m)
  }
]